<template>
  <div class="cookPattenPage">
    <div>
      <el-tag class="tagDIV">{{ $t('Common.stage') }}{{ cookPhaseObj.index + 1 }}</el-tag>
      <span class="title">{{ $t('RecipeManage.listCookingPattern3') }}</span>
    </div>
    <div style="padding-top: 24px">
      <Description>
        <DescriptionItem :span="12" :label="$t('RecipeManage.listTips8')">
          {{ patten1.temperatureDifference | format }}℃
          <span class="Funit"> ({{ CToF(patten1.temperatureDifference) }}℉)</span>
        </DescriptionItem>
        <DescriptionItem :span="12" :label="$t('RecipeManage.listTips7')">
          {{ patten1.centerTemperature | format }}℃
          <span class="Funit"> ({{ CToF(patten1.centerTemperature) }}℉)</span>
        </DescriptionItem>
        <DescriptionItem :span="12" :label="$t('RecipeManage.listTips10')"
          >{{ patten1.humidity | format }}%</DescriptionItem
        >
        <DescriptionItem :span="12" :label="$t('RecipeManage.listTips11')">
          {{ patten1.fanRotateSpeed | format }}r
          <span class="fanDes">
            {{
              patten1.fanDirection === 'ProsAndCons'
                ? $t('RecipeManage.listProsAndCons')
                : patten1.fanDirection === 'Pros'
                ? $t('RecipeManage.listPros')
                : format
            }}</span
          >
          <span class="fanDes">{{
            patten1.fanState === 'OFF'
              ? $t('RecipeManage.listOFF')
              : patten1.fanState === 'ON'
              ? $t('RecipeManage.listON')
              : format
          }}</span>
        </DescriptionItem>
        <DescriptionItem :span="24" :label="$t('RecipeManage.listPause')">
          {{
            patten1.suspendState === 'Unsuspended'
              ? $t('RecipeManage.listUnsuspended')
              : patten1.suspendState === 'Pause'
              ? $t('RecipeManage.listPause')
              : format
          }}
        </DescriptionItem>
        <DescriptionItem :span="24" :label="$t('RecipeManage.listStageDes')">{{
          patten1.remark | format
        }}</DescriptionItem>
      </Description>
    </div>
  </div>
</template>

<script>
import { CToF } from '@/utils/utils'
import Description from '@/components/Descriptions'
import DescriptionItem from '@/components/Descriptions/DescriptionsItem'
import { preModelList } from '@/config/status'
export default {
  name: 'DetailDiff',
  components: {
    Description,
    DescriptionItem
  },
  props: {
    cookPhaseObj: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      preModelList,
      patten1: {},
      temperatureUnit: localStorage.getItem('temperatureUnit'),
      listModelOption: [
        {
          value: 'THAW',
          label: this.$t('RecipeManage.listThaw')
        },
        {
          value: 'STEAM',
          label: this.$t('RecipeManage.listSteam')
        },
        {
          value: 'ROAST',
          label: this.$t('RecipeManage.listBake')
        },
        {
          value: 'BARBECUE',
          label: this.$t('RecipeManage.listBBC')
        },
        {
          value: 'FRY',
          label: this.$t('RecipeManage.listFry')
        },
        {
          value: 'GRILL',
          label: this.$t('RecipeManage.listGrill')
        },
        {
          value: 'STEW',
          label: this.$t('RecipeManage.listStew')
        },
        {
          value: 'LOW_TEMPERATURE_COOKING',
          label: this.$t('RecipeManage.listLowTCook')
        },
        {
          value: 'FERMENTATION',
          label: this.$t('RecipeManage.listFerment')
        },
        {
          value: 'HEAT_PRESERVATION',
          label: this.$t('RecipeManage.listKeepT')
        }
      ]
    }
  },
  created() {
    this.patten1 = this.cookPhaseObj
  },

  methods: {
    CToF,
    formatSlider(value) {
      return value + '%'
    }
  }
}
</script>

<style lang="scss" scoped>
.cookPattenPage {
  margin-top: 8px;
  border-radius: 8px;
  border: 1px solid #dcdfe6;
  padding: 24px;
  .fanDes {
    margin-left: 16px;
  }
  .tagDIV {
    border: 0;
    font-weight: 600;
    font-size: 12px;
    line-height: 26px;
    height: 26px;
    border-radius: 13px;
  }
  .title {
    margin-left: 8px;
    font-size: 16px;
    font-weight: 600;
    color: #333333;
    line-height: 20px;
  }
  .formContent {
    margin: 12px 0;
    height: 40px;
    display: flex;
    align-items: center;
    .spanTitle {
      text-align: right;
      min-width: 165px;
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      line-height: 32px;
      padding-right: 12px;
    }
    .Funit {
      font-size: 16px;
      margin-left: 8px;
      color: #999999;
    }
  }
  .speInput {
    width: 120px !important;
  }
  .sliderInput {
    width: 340px;
    margin-right: 24px;
  }
  .solidUnit {
    padding-left: 4px;
    color: #333333;
    line-height: 36px;
  }
}
</style>
